import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const translations = [
    {
        language: 'en',
        stats: [
            { label: 'Years of Experience in E-Learning', value: '10+' },
            { label: 'Successful Online Courses', value: '200+' },
            { label: 'Happy Students', value: '...+' },
        ],
    },
    {
        language: 'pr',
        stats: [
            { label: 'سال تجربه در آموزش الکترونیکی', value: '10+' },
            { label: 'دوره‌های آنلاین موفق', value: '200+' },
            { label: 'دانش‌آموزان خوشحال', value: '...+' },
        ],
    },
    {
        language: 'ps',
        stats: [
            { label: 'د زده کړو په الکترونیکي برخه کې کلونه تجربه', value: '10+' },
            { label: 'بریالۍ آنلاین کورسونه', value: '200+' },
            { label: 'خوښ زده کوونکي', value: '...+' },
        ],
    },
];

const VisionAndMission = () => {
    const { t, i18n } = useTranslation();

    const currentLanguageStats = translations.find(
        (translation) => translation.language === i18n.language
    )?.stats || [];

    // Animation variants
    const fadeInUp = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    };

    const fadeIn = {
        hidden: { opacity: 0 },
        visible: { opacity: 1, transition: { duration: 0.8 } },
    };

    return (
        <div className="px-6 pt-3 mx-auto sm:pt-4 sm:px-8 max-w-7xl">
            <div className="grid max-w-2xl grid-cols-1 mx-auto lg:grid-cols-2 xl:gap-x-16 lg:gap-x-8 lg:gap-y-6 lg:max-w-none lg:mx-0">
                <div className="space-y-20 mb-10">
                    <motion.div
                        className="prose"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInUp}
                    >
                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{t("about-us-introduction-to-help-title")}</h2>
                        <p className="mt-6 text-lg leading-8 text-gray-600">
                            {t("about-us-introduction-to-help-description")}
                        </p>
                    </motion.div>

                    {/* <motion.div
                        className="prose"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInUp}
                    >
                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{t("vision-title")}</h2>
                        <p className="mt-6 text-lg leading-8 text-gray-600">
                            {t("vision")}
                        </p>
                    </motion.div> */}

                    
                    {/* <motion.div
                        className="prose"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInUp}
                    >
                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{t("mission-title")}</h2>
                        <p className="mt-6 text-lg leading-8 text-gray-600">
                            {t("mission")}
                        </p>
                    </motion.div>

                    <motion.div
                        className="prose"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInUp}
                    >
                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{t("about-us-introduction-to-help-objectives")}</h2>
                        <p className="mt-6 text-lg leading-8 text-gray-600">
                            <ul className="list-disc list-inside space-y-2">
                                <li>{t("about-us-introduction-to-help-objectives-item-1")}</li>
                                <li>{t("about-us-introduction-to-help-objectives-item-2")}</li>
                                <li>{t("about-us-introduction-to-help-objectives-item-3")}</li>
                                <li>{t("about-us-introduction-to-help-objectives-item-4")}</li>
                                <li>{t("about-us-introduction-to-help-objectives-item-5")}</li>
                            </ul>
                        </p>
                    </motion.div>

                    <motion.div
                        className="prose"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInUp}
                    >
                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{t("about-us-key-features")}</h2>
                        <p className="mt-6 text-lg leading-8 text-gray-600">
                            <ul className="list-disc list-inside space-y-2">
                                <li>{t("about-us-key-features-item-1")}</li>
                                <li>{t("about-us-key-features-item-2")}</li>
                                <li>{t("about-us-key-features-item-3")}</li>
                                <li>{t("about-us-key-features-item-4")}</li>
                                <li>{t("about-us-key-features-item-5")}</li>
                            </ul>
                        </p>
                    </motion.div>

                    <motion.div
                        className="prose"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInUp}
                    >
                        <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{t("about-us-users")}</h2>
                        <p className="mt-6 text-lg leading-8 text-gray-600">
                            <ul className="list-disc list-inside space-y-2">
                                {t("about-us-users-description")}
                            </ul>
                        </p>
                    </motion.div> */}

                </div>
                
                <motion.div
                    className="hidden lg:grid h-full"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={fadeIn}
                >
                    <img
                        alt="Help in Afghanistan"
                        loading="lazy"
                        width="960"
                        height="480"
                        decoding="async"
                        className="object-cover w-full xl:rounded-3xl"
                        src="/afg.png"
                    />
                </motion.div>
            </div>
        </div>
    );
};

export default VisionAndMission;